import { render, staticRenderFns } from "./CampaignTriggerGoalHighlightProductsModal.vue?vue&type=template&id=63fd45d5"
import script from "./CampaignTriggerGoalHighlightProductsModal.vue?vue&type=script&lang=js"
export * from "./CampaignTriggerGoalHighlightProductsModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignTriggerGoalHighlightProductsModal.vue?vue&type=style&index=0&id=63fd45d5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports